import OwnerIcon from '@components/OwnerIcon';
import { Typography } from '@components/Typography';

const CardOwnerLabel = ({ type, name }) => (
    <Typography
        variant="caption"
        sx={{
            color: name ? 'var(--text-secondary)' : '#fff',
            margin: '4px 0 16px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
        }}
    >
        {name ? <OwnerIcon type={type} /> : null}
        {name}
    </Typography>
);

export default CardOwnerLabel;
